import { combineReducers } from 'redux';
import UserUpdateReducer from './UserUpdateReducer';

// Combining the reducers
export default combineReducers({
  users: UserUpdateReducer,
});
